import React, { useState } from 'react'
import clsx from 'clsx'
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer'
import { ReactComponent as Arrow } from '@/assets/icons/thin-arrow-purple.svg'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'

export function OverviewAccordion({
  items
}: {
  items: { _uid?: string; title?: string; content?: StoryblokRichtext }[]
}) {
  const [openIndexes, setOpenIndexes] = useState<number[]>([])

  const toggleAccordion = (index: number) => {
    setOpenIndexes((prevOpenIndexes) =>
      prevOpenIndexes.includes(index) ? prevOpenIndexes.filter((i) => i !== index) : [...prevOpenIndexes, index]
    )
  }

  return (
    <div className="block netbook:hidden">
      {items.map((item, index) => (
        <div key={item._uid} className="font-sans">
          <button
            type="button"
            onClick={() => toggleAccordion(index)}
            className={clsx(
              'py-8 border-b-1 border-b-primary-300 w-full flex items-center justify-between text-nowrap text-start text-bodyL text-text-dark-600',
              {
                'border-b-2 border-b-primary-500 !text-text-brand-primary font-bold': openIndexes.includes(index)
              }
            )}
          >
            {item.title}
            <Arrow
              className={clsx('transition duration-300 rotate-90', { '!-rotate-90': openIndexes.includes(index) })}
            />
          </button>
          {openIndexes.includes(index) && (
            <div
              className={clsx(
                'py-24 netbook:pt-16 netbook:pb-0 text-text-dark-600 text-bodyL font-sans  [&>p]:mb-12 [&>p:has(>a)]:mb-0 [&_a]:text-text-brand-darker [&_a]:font-semibold [&_a]:inline-block [&_a]:text-bodyL',
                index === 1 && '[&_a:not(:last-child)]:mb-16'
              )}
            >
              <RichTextField data={item.content} />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
